import { Search, ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

interface UserFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: string;
  onStatusChange: (value: string) => void;
}

export function UserFilters({ search, onSearchChange, status, onStatusChange }: UserFiltersProps) {
  const { t } = useTranslation();
  
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      {/* Search */}
      <div className="relative w-full md:w-96">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          placeholder={t('admin.users.searchPlaceholder')}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full rounded-lg border-2 border-black px-10 py-2.5 font-medium placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF6B9D] focus:ring-offset-2"
        />
      </div>

      {/* Filter Options */}
      <div className="flex items-center gap-3">
        <div className="relative">
          <select
            value={status}
            onChange={(e) => onStatusChange(e.target.value)}
            className="appearance-none rounded-lg border-2 border-black bg-white pl-4 pr-7 py-2.5 font-bold focus:outline-none focus:ring-2 focus:ring-[#FF6B9D] focus:ring-offset-2 cursor-pointer"
          >
            <option value="all">{t('admin.users.filters.allStatus')}</option>
            <option value="active">{t('admin.users.filters.active')}</option>
            <option value="pro">{t('admin.users.filters.pro')}</option>
            <option value="trial">{t('admin.users.filters.trial')}</option>
            <option value="basic">{t('admin.users.filters.basic')}</option>
            <option value="gifted">{t('admin.users.filters.gifted')}</option>
            <option value="suspended">{t('admin.users.filters.suspended')}</option>
          </select>
          <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 pointer-events-none text-gray-500" />
        </div>
        
        {/* Export Button (Phase 2?) */}
        <button className="rounded-lg border-2 border-black bg-white px-4 py-2.5 font-bold shadow-[2px_2px_0_#000] hover:bg-gray-50 active:translate-y-[2px] active:translate-x-[2px] active:shadow-none">
          {t('admin.users.exportCsv')}
        </button>
      </div>
    </div>
  );
}
